<template>
    <div class="privacy">
        <div id="privacy" class="privacy beige coo">
            <div class="container" v-if="this.dataLoaded">
                <div>
                    <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000" >{{page.attributes.title}}</h1>
                </div>
                <div>
                    <p v-html="this.page.attributes.field_description.processed"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'privacy-policy',
    data:()=>{
        return {
            idIntroPage:"7bfe09eb-86e1-460e-9ab3-7c926fbced5c",
            page:[],
            dataLoaded:false,
            lang:"it",
            langData: "it",
        }
    },
    methods:{
        findObjectbyKey:(array, key, value)=>{
            for (var i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    return array[i];
                }
            }
            return null;
        },
        fetchData: function () {
            const jsondaSistemare = "https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page"
            fetch(jsondaSistemare, {method: "GET", mode: 'cors'})
            .then(response=>{
                return response.json()
            })
            .then(json=>{
                this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
                                console.log('json p',this.page);

                this.dataLoaded = true
            })
            .catch(function(error) {  
                console.log('Request failed', error)  
            });
        }
    },
    watch:{
        $route (){
            if(this.$route.params.lang == "en"){
                this.langData = "en"
            } else {
                this.langData = "it"
            }
            this.fetchData()
            }, 
    },

    created(){        
        this.fetchData()
        window.scrollTo(0,20)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">


</style>
